<script>
import {
  maxValue,
  minValue,
  required,
  requiredIf
} from "vuelidate/lib/validators";
import { shouldBeYesIf } from "@/validations/shouldBeYesIf";

export default {
  methods: {
    showServiceRequirement(design) {
      return (
        +design.service_requirement_employee_deferrals === 1 ||
        +design.service_requirement_employee_deferrals === 2
      );
    },
    serviceRequirementValidations(design) {
      return {
        service_requirement_employee_deferrals: { required },
        service_requirement_measurement_number: {
          required: requiredIf(() => this.showServiceRequirement(design)),
          minValue: minValue(0),
          maxValue: maxValue(12)
        },
        service_requirement_sync: {
          required: requiredIf(() => this.showServiceRequirement(design)),
          shouldBeYes: shouldBeYesIf(
            design.service_requirement_measurement_number >
              design.service_requirement_match_measurement_number
          )
        }
      };
    }
  }
};
</script>
